import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";

function Index(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box bgcolor='#f5f7fb'>
                    {children}
                </Box>
            )}
        </div>
    );
}

Index.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export default Index;
